<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { SessionHelper, LANG } from "./utils/session";
export default {
  methods:{
      changeLocale(locale) {
      if (["kn", "ml"].includes(SessionHelper.getCookie(LANG))) {
        document.querySelector("body").classList.add("activeKannada");
      }
      if (["ta"].includes(SessionHelper.getCookie(LANG))) {
        document.querySelector("body").classList.add("activeTamil");
      }
      this.$i18n.locale = SessionHelper.getCookie(LANG) || "hi";
    }
  },
  mounted(){
	this.changeLocale()
  }
}
</script>
<style >
.alertMsg{
	    font-size: 0.875em;
    color: #ff4643;
    margin-bottom: 10px;
}
.loader{
  position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #f4f6f87d;
    z-index: 9;
}
.loader img{
      top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50% , -50%);
}
.customModal {
	 position: fixed;
	 top: 0;
	 left: 0;
	 right: 0;
	 bottom: 0;
	background: rgba(28, 28, 28, 0.62);
	 z-index: 99;
}
 .customModal .modal_dialog {
	 position: absolute;
	 top: 50%;
	 left: 50%;
	 transform: translate(-50%, -50%);
	 width: 80%;
	 background: #fff;
	 transition: transform 0.3s ease-out;
}
 .customModal .modal_dialog {
	 border-radius: 5px;
	 font-family: 'Roboto', sans-serif;
}
 .customModal .modal_dialog .modal_header {
	 display: flex;
	 justify-content: space-between;
	 align-items: center;
	 border: 0;
	 padding: 0;
	 padding-right: 5px;
}
 .customModal .modal_dialog .modal_content h3 {
	 font-size: 1em;
	 text-align: left;
	 font-weight: 500;
	 padding:15px;
}
 .customModal .modal_dialog .modal_content .close_icon {
	 font-size: 20px;
	 font-weight: 700;
	 position: absolute;
	 top: 5px;
	 right: 10px;
}
 .customModal .modal_dialog .modal_body {
	 padding: 5px 35px 5px 0;
}
 .customModal .modal_dialog .modal_body.padding0 {
	 padding: 0;
}
 .customModal .modal_dialog .modal_body p {
	 font-size: 0.875em;
	 font-weight: normal;
}
 .customModal .modal_dialog .modal_footer {
   text-align: right;
       display: flex;
	justify-content: space-between;
	border-top: 1px solid #ccc;
}
 .customModal .modal_dialog .modal_footer button {
	 border: 0;
	 color: #fff;
	     padding: 10px 10px;
    width: 50%;
	background: #fff;
	    font-size: 1em;
}
 .customModal .modal_dialog .modal_footer button.yes{
   background: #0078FF;
   border-bottom-right-radius: 5px;
 }
 .customModal .modal_dialog .modal_footer button.no{
   color: #0078FF;
   border-bottom-left-radius: 5px;
 }
</style>